import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Text,
  Toast,
  ToastTitle,
  useToastController,
  makeStyles,
  tokens,
  Toaster
} from "@fluentui/react-components";
import { Checkmark24Regular } from "@fluentui/react-icons";
import { ENV_REACT_APP_UNARIC_UNIFY_SYNC_APPROVE, ENV_REACT_APP_UNARIC_UNIFY_CLIENT_APPROVE } from "./AdminConstant";
import AdminService from "./AdminService";
import { useAdminAuth } from "./AdminAuthContext";
import { useSearchParams } from "react-router";
import { formatDateTime } from "./adminUtil";
const useStyles = makeStyles({
  row: {
    display: "flex",
    flexDirection: "column",
    padding: "12px",
    border: `1px solid ${tokens.colorNeutralStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
    marginBottom: "12px",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  infoDiv: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginTop: "10px",
  },
  rowTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  meta: {
    fontSize: "12px",
    color: tokens.colorNeutralForeground3,
  },
});

export default function UnifySyncApprove() {
  const styles = useStyles();
  const toasterId = "sync-approve-toaster";
  const { dispatchToast } = useToastController(toasterId);
  const { userInfo } = useAdminAuth();
  const [userApproveInfo, setUserApproveInfo] = useState(null);
  const [searchParams] = useSearchParams();
  const hasHandledConsent = useRef(false);
  // 🔹 Fetch sync info

  const fetchUserInfo = async () => {
    try {
      if (!userInfo?.userObjectId || !userInfo?.tenantId) return;

      const res = await AdminService.getUserInfo();

      setUserApproveInfo({
        syncOwner: res?.syncOwner,
        syncCreatedAt: res?.syncCreatedAt,
        clientOwner: res?.clientOwner,
        clientCreatedAt: res?.clientCreatedAt,
      });
    } catch (err) {
      console.error("User Info API Error", err);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, [userInfo]);

  const handleApprove = async (appApproval) => {
    try {
      if (appApproval === "client") {
        const clientCreatedAt = new Date().toISOString();

        // 🔹 Call API
        await AdminService.postAdminOnboardingClient(
          clientCreatedAt,
        );
        fetchUserInfo();
        dispatchToast(
          <Toast>
            <ToastTitle>Unaric Voice for Teams Client App approved successfully ✅</ToastTitle>
          </Toast>,
          { intent: "success" },
        );
      } else {
        const syncCreatedAt = new Date().toISOString();

        // 🔹 Call API for Sync Onboarding
        await AdminService.postAdminOnboardingSync(
          syncCreatedAt,
        );
        fetchUserInfo();
        dispatchToast(
          <Toast>
            <ToastTitle>Unaric Voice for Teams Sync App approved successfully ✅</ToastTitle>
          </Toast>,
          { intent: "success" },
        );
      }

    } catch (err) {
      console.error("App approval failed:", err);

      dispatchToast(
        <Toast>
          <ToastTitle>App approval failed ❌</ToastTitle>
        </Toast>,
        { intent: "error" },
      );
    }
  };
  //  Auto trigger after admin consent
  useEffect(() => {
    const consent = searchParams.get("admin_consent");
    const tenantFromUrl = searchParams.get("tenant");
    const appApproval = searchParams.get("app");

    if (
      hasHandledConsent.current ||
      consent !== "True" ||
      !tenantFromUrl ||
      !userInfo
    ) {
      return;
    }

    hasHandledConsent.current = true;

    console.log("Admin consent detected ", tenantFromUrl);

    handleApprove(appApproval);

    //  Clean URL after processing
    window.history.replaceState(
      {},
      document.title,
      "/?page=authorization",
    );
  }, [searchParams, userInfo]);
  return (
    <>
      <Toaster toasterId={toasterId} />
      <div className={styles.row}>
        <div className={styles.rowTop}>
          <Text>Unaric Voice for Teams Client</Text>

          <Button
            appearance="primary"
            as="a"
            icon={<Checkmark24Regular />}
            href={ENV_REACT_APP_UNARIC_UNIFY_CLIENT_APPROVE}
          >
            Approve
          </Button>
        </div>

        {userApproveInfo?.clientOwner && (
          <div className={styles.infoDiv}>
            <Text className={styles.meta}>
              Client Approved by: <b>{userApproveInfo?.clientOwner}</b>
            </Text>

            <Text className={styles.meta}>
              Client Approved at (UTC):{" "}
              <b>
                {userApproveInfo?.clientCreatedAt
                  ? formatDateTime(userApproveInfo?.clientCreatedAt)
                  : "-"}
              </b>
            </Text>
          </div>
        )}
      </div>
      <div className={styles.row}>
        <div className={styles.rowTop}>
          <Text>Unaric Voice for Teams Sync</Text>

          <Button
            appearance="primary"
            as="a"
            icon={<Checkmark24Regular />}
            href={ENV_REACT_APP_UNARIC_UNIFY_SYNC_APPROVE}
          >
            Approve
          </Button>
        </div>

        {/* Sync Info UI */}
        {userApproveInfo?.syncOwner && (
          <div className={styles.infoDiv}>
            <Text className={styles.meta}>
              Sync Approved by: <b>{userApproveInfo?.syncOwner}</b>
            </Text>

            <Text className={styles.meta}>
              Sync Approved at (UTC):{" "}
              <b>
                {userApproveInfo?.syncCreatedAt
                  ? formatDateTime(userApproveInfo?.syncCreatedAt)
                  : "-"}
              </b>
            </Text>
          </div>
        )}
      </div>

    </>
  );
}
